/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const notificationLevelEnumSchema = z
	.enum(["Error", "Timeout", "Warning", "Critical"])
	.describe("* `Error` - Ошибка\n* `Timeout` - Tаймаут\n* `Warning` - Предупреждение\n* `Critical` - Критическая ошибка");
